module.exports = __webpack_public_path__ + "img/featureCosme.006.40fef372.jpeg";